module.exports = __webpack_public_path__ + "img/ld-logo-square.12d35aa3.svg";